module.exports = __webpack_public_path__ + "assets/certificate_pdf/ssa_113_14.8413556c.pdf";